import ReviewTemplatePanel from './ReviewTemplatePanel'

export default ReviewTemplatePanel
